export default {
  add: 'PRODUCT_MUTATIONS_ADD',
  addMissingProductId: 'PRODUCT_MUTATIONS_ADD_MISSING_PRODUCT_ID',
  edit: 'PRODUCT_MUTATIONS_EDIT',
  delete: 'PRODUCT_MUTATIONS_DELETE'
}
